export const DEFAULT_ROUTE = '/home';
